import { useMutation, useQuery } from 'react-query'
import { AnnotationPostModel, createAnnotation, getAnnotations } from './annotation'

export const useGetAnnotations = (serviceId: number | undefined) => useQuery(['annotations', serviceId], () => getAnnotations(serviceId))

export const useCreateAnnotation = () => useMutation((newAnnotation: AnnotationPostModel) => createAnnotation(newAnnotation), {

})